import { Component, OnInit } from '@angular/core';
import {Provedor} from "./provedor";
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ProvedorService} from "../Services/provedor.service";

@Component({
  selector: 'app-provedor',
  templateUrl: './provedor.component.html',
  styleUrls: ['./provedor.component.css']
})
export class ProvedorComponent implements OnInit {

  msgs: Message[] = [];
  formProvedor : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  tiposDocumento = [];
  panelRequeridos = false;
  loading = false;
  ProvedorsRegistrados:Provedor[];
  ProvedorSeleccionado:Provedor;
  tipoGuardado = '';

  constructor(private servicioProvedor:ProvedorService,private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesProvedor();
    this.Cancelar();
    this.poblarTiposDoc();
    this.listarProvedors();
  }


  crearControlesProvedor(){
    this.formProvedor = this.fb.group({
        nombre:['',Validators.required],
      nit:['',Validators.required],
      direccion:['',Validators.required],
      telefono:[''],
      movil:['',Validators.required],
      pais:[''],
      ciudad:[''],
      departamento:[''],
      personaContacto:['',Validators.required],
      web:[''],
      correo:[''],
      entidadBancaria:[''],
      numeroCuenta:[''],
      observaciones:[''],
      }
    );

  }
  nuevoProvedor(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formProvedor.enable();
    this.formProvedor.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formProvedor.reset();
    this.formProvedor.disable();
    this.panelRequeridos = false;
  }
  poblarTiposDoc(){
    this.tiposDocumento.push({label:'Seleccione un Tipo', value:''});
    this.tiposDocumento.push({label:'C.C', value:'C.C'});
    this.tiposDocumento.push({label:'PASAPORTE', value:''});
    this.tiposDocumento.push({label:'C.E.', value:''});
    this.tiposDocumento.push({label:'DNI', value:''});
    this.tiposDocumento.push({label:'NIT', value:''});
    this.tiposDocumento.push({label:'NUIP', value:''});
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoProvedor(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioProvedor.putProvedor(this.formProvedor.value,this.ProvedorSeleccionado.id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarProvedors();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioProvedor.addProvedor(this.formProvedor.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarProvedors();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarProvedors(){
    this.loading = true;
    this.servicioProvedor.getProvedor()
      .subscribe(
        rt => {
          this.ProvedorsRegistrados = rt;
          console.log(this.ProvedorsRegistrados);
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarProvedor(item:Provedor){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formProvedor.enable();
    this.panelRequeridos = true;
    this.ProvedorSeleccionado = item;
    this.ProvedorDetalle(item);
    this.tipoGuardado = 'editar';
  }
  ProvedorDetalle(item:Provedor):void {
   this.formProvedor.patchValue({
   id:item.id,
     nombre:item.nombre,
     nit:item.nit,
     direccion:item.direccion,
     telefono:item.telefono,
     movil:item.movil,
     pais:item.pais,
     ciudad:item.ciudad,
     departamento:item.departamento,
     personaContacto:item.personaContacto,
     web:item.web,
     correo:item.correo,
     entidadBancaria:item.entidadBancaria,
     numeroCuenta:item.numeroCuenta,
     observaciones:item.observaciones,

   });
   }

}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/provedor/provedor.component.ts